import { render, staticRenderFns } from "./stockAllocationDetail.vue?vue&type=template&id=b165f318&scoped=true&"
import script from "./stockAllocationDetail.vue?vue&type=script&lang=js&"
export * from "./stockAllocationDetail.vue?vue&type=script&lang=js&"
import style0 from "./stockAllocationDetail.vue?vue&type=style&index=0&id=b165f318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b165f318",
  null
  
)

export default component.exports